// extracted by mini-css-extract-plugin
module.exports = {"home":"About_home__15OjK","mainBox":"About_mainBox__2lq2Y","infoBox":"About_infoBox__3JGn0","developerImage":"About_developerImage__2OpuW"};